export default __webpack_public_path__ + "static/media/pen.24c1ae55.svg";